var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mitra-logos"
  }, [_c('div', {
    staticClass: "flex justify-between items-center mdmax:flex-col mdmax:mb-4 border-b border-nn-100"
  }, [_vm._m(0), _c('Button', {
    attrs: {
      "buttonText": "Tambah Logo",
      "type": "primary"
    },
    on: {
      "action": function ($event) {
        return _vm.addNew();
      }
    }
  })], 1), _c('div', {
    staticClass: "flex items-center gap-4 mb-4 pt-4"
  }, [_c('p', {
    staticClass: "whitespace-nowrap text-nn-600"
  }, [_vm._v("Menampilkan daftar logo:")]), _c('div', {
    staticClass: "w-40"
  }, [_c('CustomSelect', {
    attrs: {
      "options": _vm.partnerOptions,
      "placeholder": "Pilih partner",
      "optionLabel": "label",
      "default": _vm.selectedPartnerOption
    },
    model: {
      value: _vm.selectedPartnerOption,
      callback: function ($$v) {
        _vm.selectedPartnerOption = $$v;
      },
      expression: "selectedPartnerOption"
    }
  })], 1)]), !!_vm.partnerLogos.length ? _c('div', {
    staticClass: "bg-white p-4 rounded-lg grid grid-cols-6 gap-4 mdmax:grid-cols-2"
  }, _vm._l(_vm.partnerLogos, function (logo) {
    return _c('div', {
      key: logo.id,
      staticClass: "border border-neutral-100 rounded-lg flex flex-col items-center justify-center"
    }, [_c('div', {
      staticClass: "square flex w-full items-center justify-center p-2"
    }, [logo.image_url ? _c('img', {
      attrs: {
        "src": logo.image_url
      }
    }) : _c('PlaceholderImage', {
      attrs: {
        "width": "80",
        "height": "80"
      }
    })], 1), _c('p', {
      staticClass: "text-sm text-neutral-600 mb-4 w-full px-2 text-center"
    }, [_vm._v(" " + _vm._s(logo.partner_name) + " ")]), _c('div', {
      staticClass: "flex justify-center items-center gap-x-2 w-full border-t border-nn-100 p-2 bg-system-gray"
    }, [_c('Button', {
      attrs: {
        "buttonText": "",
        "type": "delete",
        "size": "small",
        "icon": function () {
          return import('@/components/Icons/Trash');
        }
      },
      on: {
        "action": function ($event) {
          return _vm.toggleDeleteLogo(logo);
        }
      }
    }), _c('Button', {
      attrs: {
        "buttonText": "",
        "type": "secondary",
        "size": "small",
        "icon": function () {
          return import('@/components/Icons/Pencil');
        }
      },
      on: {
        "action": function ($event) {
          return _vm.edit(logo);
        }
      }
    })], 1)]);
  }), 0) : _c('div', {
    staticClass: "text-nn-600 h-56 flex justify-center items-center"
  }, [_vm._v(" - Tidak ada data yang tersedia - ")]), _c('Modal', {
    attrs: {
      "modalVisible": _vm.visibleAddLogo,
      "id": "add-logo-modal"
    },
    on: {
      "close": _vm.toggleAddLogo
    }
  }, [_c('template', {
    slot: "modal-content"
  }, [_c('p', {
    staticClass: "mt-2 mb-4 font-bold text-xl text-left"
  }, [_vm._v(" " + _vm._s(_vm.mode === "add" ? "Tambah" : "Ubah") + " Logo Mitra ")]), _c('div', {
    staticClass: "mb-6 relative text-left flex gap-x-4 items-center"
  }, [_vm.currentLogo && !_vm.image ? _c('div', {}, [_c('p', {
    staticClass: "text-xs text-nn-500 mb-1"
  }, [_vm._v("Logo saat ini")]), _c('div', {
    staticClass: "border overflow-hidden rounded-lg flex justify-center items-center w-32 text-center p-4"
  }, [_c('img', {
    attrs: {
      "src": _vm.currentLogo
    }
  })])]) : _vm._e(), _vm.image ? _c('div', {}, [_c('div', {
    staticClass: "border overflow-hidden rounded-lg flex justify-center items-center w-32 text-center p-4"
  }, [_c('img', {
    attrs: {
      "src": _vm.image
    }
  })])]) : _c('div', {
    staticClass: "image-upload"
  }, [_c('input', {
    ref: "photo",
    staticClass: "hidden",
    attrs: {
      "type": "file",
      "name": "photo",
      "id": "photo",
      "accept": ".jpg, .png, .jpeg"
    },
    on: {
      "change": function ($event) {
        return _vm.handleFileSelect($event);
      }
    }
  }), _c('label', {
    staticClass: "border border-dashed p-4 rounded-lg flex gap-x-4 bg-nn-50 justify-center items-center border-neutral-500 text-neutral-500 text-center cursor-pointer",
    attrs: {
      "for": "photo"
    }
  }, [_c('Upload', {
    attrs: {
      "width": "24",
      "height": "24"
    }
  }), _vm._v(_vm._s(_vm.mode === "add" ? "Upload" : "Ubah") + " Logo ")], 1)])]), _c('div', {
    staticClass: "mb-4 text-left"
  }, [_c('p', {
    staticClass: "text-sm mb-1"
  }, [_vm._v("Mitra")]), _c('CustomSelect', {
    attrs: {
      "options": _vm.partnerOptions,
      "placeholder": "Pilih partner",
      "optionLabel": "label",
      "default": _vm.selectedPartnerOptionForAddNew
    },
    model: {
      value: _vm.selectedPartnerOptionForAddNew,
      callback: function ($$v) {
        _vm.selectedPartnerOptionForAddNew = $$v;
      },
      expression: "selectedPartnerOptionForAddNew"
    }
  })], 1), _c('div', {
    staticClass: "mb-10 text-left"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Nama Mitra",
      "placeholder": "Masukan nama mitra"
    },
    model: {
      value: _vm.partnerName,
      callback: function ($$v) {
        _vm.partnerName = $$v;
      },
      expression: "partnerName"
    }
  })], 1), _c('div', {
    staticClass: "flex items-center gap-x-4 mb-10 mdmax:flex-col mdmax:items-start"
  }, [_c('div', {
    staticClass: "flex items-center mb-5 gap-x-4"
  }, [_c('p', {
    staticClass: "text-sm font-medium"
  }, [_vm._v("Aktif")]), _c('div', {
    staticClass: "flex gap-2 items-center"
  }, [_c('Toggle', {
    attrs: {
      "id": "active"
    },
    model: {
      value: _vm.isActive,
      callback: function ($$v) {
        _vm.isActive = $$v;
      },
      expression: "isActive"
    }
  })], 1)]), _c('div', {
    staticClass: "flex items-center mb-5 gap-x-4"
  }, [_c('p', {
    staticClass: "text-sm font-medium"
  }, [_vm._v("Business")]), _c('div', {
    staticClass: "flex gap-2 items-center"
  }, [_c('Toggle', {
    attrs: {
      "id": "business"
    },
    model: {
      value: _vm.isBusiness,
      callback: function ($$v) {
        _vm.isBusiness = $$v;
      },
      expression: "isBusiness"
    }
  })], 1)]), _c('div', {
    staticClass: "flex items-center mb-5 gap-x-4"
  }, [_c('p', {
    staticClass: "text-sm font-medium"
  }, [_vm._v("Apps")]), _c('div', {
    staticClass: "flex gap-2 items-center"
  }, [_c('Toggle', {
    attrs: {
      "id": "apps"
    },
    model: {
      value: _vm.isApp,
      callback: function ($$v) {
        _vm.isApp = $$v;
      },
      expression: "isApp"
    }
  })], 1)])]), _c('div', {
    staticClass: "flex justify-end items-center gap-4"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Batal",
      "type": "secondary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.toggleAddLogo();
      }
    }
  }), _c('Button', {
    attrs: {
      "buttonText": _vm.mode === 'add' ? 'Tambah' : 'Ubah',
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.addLogo();
      }
    }
  })], 1)])], 2), _c('Modal', {
    attrs: {
      "modalVisible": _vm.visibleDeleteConfirmation,
      "id": "confirmation-logo-modal"
    },
    on: {
      "close": function ($event) {
        _vm.visibleDeleteConfirmation = false;
      }
    }
  }, [_c('template', {
    slot: "modal-content"
  }, [_c('div', {
    staticClass: "text-cente mt-6 mb-4"
  }, [_vm._v(" Apakah Anda yakin akan menghapus logo mitra ini? ")]), _c('div', {
    staticClass: "flex justify-center items-center gap-4"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Ya",
      "type": "secondary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.deleteItem();
      }
    }
  }), _c('Button', {
    attrs: {
      "buttonText": "Tidak",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        _vm.visibleDeleteConfirmation = false;

        _vm.resetForm();
      }
    }
  })], 1)])], 2)], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {}, [_c('p', {
    staticClass: "font-bold text-xl"
  }, [_vm._v("Logo Partner")]), _c('p', {
    staticClass: "text-sm text-nn-500 mb-6"
  }, [_vm._v(" Daftar logo mitra logistik dan mitra bisnis yang akan ditampilkan sesuai urutan pada halaman website linknau. ")])]);

}]

export { render, staticRenderFns }